import { render } from "./SectionsDetailTableStaticData.vue?vue&type=template&id=22df0ae2"
import script from "./SectionsDetailTableStaticData.vue?vue&type=script&lang=js"
export * from "./SectionsDetailTableStaticData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__